import { render, staticRenderFns } from "./repairRegisterModal.vue?vue&type=template&id=611e606d"
import script from "./repairRegisterModal.vue?vue&type=script&lang=js"
export * from "./repairRegisterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports